module.exports = __webpack_public_path__ + "img/188-Schiefergrau Veiné.jpg";